import React, { useState } from 'react';

import { Link } from 'react-router-dom';
import { Row } from 'react-bootstrap';
import { validatePermission } from 'actions/index';

import Modal from 'v3/components/Modal';
import Button from 'v3/components/Button';
import Text from 'v3/components/Text';

import { useShippingCompany } from '../../shared/context';

function Registered({ isOpen, onClose }) {
  const shippingCompany = useShippingCompany();

  const [hasPermissionToCreate] = useState(validatePermission('CADASTRAR_TRANSPORTADORAS'));

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      heading="Cadastro de transportadora"
      size="lg"
      body={
        <Row className="mx-0 mt-1">
          <Text weight="400" color="dark">
            Transportadora {shippingCompany.data.social_name} cadastrada com sucesso!
          </Text>
        </Row>
      }
      footer={
        <div className="d-flex justify-content-end align-items-center flex-wrap mr-3 mt-1" style={{ gap: 8 }}>
          <Link to="/transportadoras">
            <Button variant="white" outlined size="sm">
              <Text weight="500">Ver listagem</Text>
            </Button>
          </Link>

          <Link to={`/transportadoras/${shippingCompany?.data.id}`}>
            <Button variant="primary" size="sm">
              <Text weight="500">Ver transportadora</Text>
            </Button>
          </Link>

          {hasPermissionToCreate && (
            <Button
              variant="success"
              size="sm"
              onClick={() => {
                window.location.reload(false);
              }}
            >
              <Text weight="500">Nova transportadora</Text>
            </Button>
          )}
        </div>
      }
    />
  );
}

export default Registered;
